<div class="!h-7 cursor-pointer !w-7 flex justify-center items-center baggage-info" 
    (mouseenter)="onTriggerEnter($event, op)" (mouseleave)="onTriggerLeave(op)">
    <i class="sctr-icon-info-circle text-palette-blue-600 text-base !leading-5"></i>
    <p-overlayPanel #op>
        <ng-container>
            <div
                (mouseenter)="onPanelEnter()"
                (mouseleave)="onPanelLeave(op)"
                class="popup-container scroll-auto border border-palette-gray-200 rounded-xl font-inter 
                        !p-3 bg-white z-[14] overflow-y-auto transition-all max-sm:w-[270px] sm:w-[350px]"
            >
                <!-- HEADER -->
                <div class="flex flex-row !gap-2 !p-4 border border-palette-blue-600 rounded-xl bg-palette-blue-50">
                    <i class="sctr-icon-info-circle text-palette-blue-600 text-xl"></i>
                    <p class="text-palette-gray-700 font-normal text-sm">
                        <span>{{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.AIRLINE_BAGGAGE_RULE_VARY'
                            | translate}}</span>
                        <span class="font-semibold">{{SOCTRIP_HOTLINE}}</span>
                    </p>
                </div>
                <!-- BODY -->
                <div *ngIf="operatingCode === 'VJ'"
                    class="text-palette-gray-900 text-sm space-y-3 !mt-3">
                    <div class="space-y-1">
                        <p class="font-medium">
                            {{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.CABIN_BAGGAGE'
                            | translate}}:</p>
                        <p class="font-normal"><span class="text-palette-gray-400">•</span>
                            {{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.CABIN_BAGGAGE_DESR'
                            | translate}}</p>
                    </div>
                    <div class="space-y-1">
                        <p class="font-medium">
                            {{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.NORMAL_CHECKED_BAGGAGE'
                            | translate}}:</p>
                        <p class="font-normal"><span class="text-palette-gray-400 ">•</span>
                            {{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.NORMAL_CHECKED_BAGGAGE_WEIGHT_DESC'
                            | translate}}</p>
                        <p class="font-normal"><span class="text-palette-gray-400 ">•</span>
                            {{'FLIGHT.SEARCH_RESULT.BAGGAGE_DETAILS_POPUP.NORMAL_CHECKED_BAGGAGE_DIMENSIONS_DESC'
                            | translate}}</p>
                    </div>
                </div>
            </div>
        </ng-container>
    </p-overlayPanel>
</div>